// extracted by mini-css-extract-plugin
module.exports = {"container":"banks_container__X_yWc","title":"banks_title__kPoWn","image-section":"banks_image-section__eu843","img":"banks_img__2S8OP"};